import { useState } from 'react'
import React from 'react'
import Button from 'component/Button'
import FooterLinks from 'component/FooterLinks'
import LogoAurumPixel from 'svg/logos/aurum-pixel.svg'
import SocialLinks from 'component/SocialLinks'
import { Location } from '@reach/router'

export function Footer() {
	const [footerShowMore, setFooterShowMore] = useState(false)

	const shortFooterLinks1 = [
		{
			id: 1,
			text: 'Como escolher o melhor software jurídico',
			link: '/blog/melhor-software-juridico-do-mercado/',
		},
		{
			id: 2,
			text: 'Software jurídico gratuito: 5 critérios de escolha',
			link: '/blog/software-juridico-gratuito/',
		},
		{
			id: 3,
			text: 'Melhores aplicativos para advogados modernos',
			link: '/blog/aplicativos-para-advogados/',
		},
		{
			id: 4,
			text: 'Como calcular a prescrição penal',
			link: '/blog/prescricao-penal/',
		},
	]

	const extraFooterLinks1 = [
		{
			id: 5,
			text: 'Conheça os requisitos do usucapião',
			link: '/blog/usucapiao/',
		},
		{
			id: 6,
			text: 'Análise do art. 485 do Novo CPC',
			link: '/blog/art-485-novo-cpc/',
		},
		{
			id: 7,
			text: 'Medidas protetivas no ordenamento jurídico brasileiro',
			link: '/blog/medidas-protetivas/',
		},
		{
			id: 8,
			text: 'Como funcionam os embargos à execução',
			link: '/blog/embargos-a-execucao/',
		},
	]

	const shortFooterLinks2 = [
		{
			id: 1,
			text: 'Dicas eficientes de gestão de escritório de advocacia',
			link: '/blog/gestao-de-escritorio-de-advocacia/',
		},
		{
			id: 2,
			text: ' Como fazer o escritório de advocacia crescer de exponencialmente',
			link: '/blog/como-fazer-o-escritorio-de-advocacia-crescer/',
		},
		{
			id: 3,
			text: 'Abandone as planilhas de controle de processos judiciais',
			link: '/blog/controle-de-processos-judiciais/',
		},
		{
			id: 4,
			text: 'Entenda o cumprimento de sentença no CPC',
			link: '/blog/cumprimento-de-sentenca/',
		},
	]

	const extraFooterLinks2 = [
		{
			id: 5,
			text: 'Quais são os ritos trabalhistas',
			link: '/blog/ritos-trabalhistas/',
		},
		{
			id: 6,
			text: 'Prescrição intercorrente no Novo CPC',
			link: '/blog/prescricao-intercorrente/',
		},
		{
			id: 7,
			text: 'Como fazer as alegações finais [+MODELO]',
			link: '/blog/alegacoes-finais/',
		},
		{
			id: 8,
			text: 'Guia completo de agravo de instrumento [+MODELO]',
			link: '/blog/agravo-de-instrumento/',
		},
	]

	const shortFooterLinks3 = [
		{
			id: 1,
			text: 'Software jurídico',
			link: '/blog/categoria/software-juridico/',
		},
		{
			id: 2,
			text: 'O software jurídico Astrea é bom?',
			link: '/blog/astrea-e-bom/',
		},
		{
			id: 3,
			text: 'Código Processual Civil Comentado',
			link: '/blog/novo-cpc-comentado/',
		},
		{
			id: 4,
			text: 'Código Processual Penal Comentado',
			link: '/blog/cpp-comentado/',
		},
	]

	const extraFooterLinks3 = [
		{
			id: 5,
			text: 'Código de Defesa do Consumidor Comentado',
			link: '/blog/cdc-comentado/',
		},
		{
			id: 6,
			text: '6 planilhas gratuitas para advogados',
			link: '/blog/planilhas-para-advogados/',
		},
		{
			id: 7,
			text: 'Kit de peças processuais cíveis',
			link: '/blog/material/kit-pecas-processuais-civeis/',
		},
		{
			id: 8,
			text: 'Entenda o que é compliance',
			link: '/blog/compliance/',
		},
	]

	return (
		<footer className={`footer`}>
			<div className="footer_main">
				<div className="footer_inner">
					<LogoAurumPixel className="footer_symbol" />
					<div className="footer_links-wrapper">
						{footerShowMore ? (
							<div className="footer_links-column">
								<FooterLinks
									title={'Conteúdos mais lidos'}
									items={shortFooterLinks1.concat(extraFooterLinks1)}
								/>
								<span
									className="footer_show-more footer_arrow-up"
									onClick={() => setFooterShowMore(false)}
								>
									Ver menos
								</span>
							</div>
						) : (
							<div className="footer_links-column">
								<FooterLinks
									title={'Conteúdos mais lidos'}
									items={shortFooterLinks1}
								/>
								<span
									className="footer_show-more footer_arrow-down"
									onClick={() => setFooterShowMore(true)}
								>
									Ver mais
								</span>
							</div>
						)}
						{footerShowMore ? (
							<div className="footer_links-column">
								<FooterLinks
									title={'Conteúdos recomendados'}
									items={shortFooterLinks2.concat(extraFooterLinks2)}
								/>
							</div>
						) : (
							<div className="footer_links-column">
								<FooterLinks
									title={'Conteúdos recomendados'}
									items={shortFooterLinks2}
								/>
							</div>
						)}
						{footerShowMore ? (
							<div className="footer_links-column">
								<FooterLinks
									title={'Assuntos mais buscados'}
									items={shortFooterLinks3.concat(extraFooterLinks3)}
								/>
							</div>
						) : (
							<div className="footer_links-column">
								<FooterLinks
									title={'Assuntos mais buscados'}
									items={shortFooterLinks3}
								/>
							</div>
						)}
					</div>
					<div className="footer_tools">
						<Location>
							{({ location }) => {
								if (location.pathname === '/themis-para-departamento-juridico/')
									return (
										<Button
											link="/experimente-o-themis-dj/"
											title="Agende uma demonstração"
											className="btn-themis"
										/>
									)
								if (
									location.pathname ===
										'/calculadora-de-prazos-processuais-themis/' ||
									location.pathname ===
										'/calculadora-de-prazos-processuais-themis/calendario-de-feriados/'
								)
									return (
										<Button
											link="/experimente-o-themis-dj/"
											title="Agende uma demonstração"
											className="btn-themis"
										/>
									)
								if (
									location.pathname === '/themis-para-escritorios-de-advocacia/'
								)
									return (
										<Button
											link="/experimente-o-themis-ea/"
											title="Agende uma demonstração"
											className="btn-themis"
										/>
									)
								else
									return (
										<Button
											link="/astrea-login/"
											title="Acesse o Astrea"
											className="btn-astrea"
										/>
									)
							}}
						</Location>
						<Button
							link="/contato/"
							title="Dúvidas? Fale conosco!"
							className="btn-alpha"
						/>
						<SocialLinks />
					</div>
				</div>
			</div>
			<div className="footer_base">
				<div className="footer_copyright">
					<span
						className="footer_copyright_text manage_cookies_button"
						onClick={() => window.sendAdoptCommand('open')}
					>
						Gerenciar Cookies.
					</span>

					<span className="footer_copyright_text">
						Ao acessar você concorda com a{' '}
						<a
							target="_blank"
							rel="noreferrer"
							href="https://s3.sa-east-1.amazonaws.com/publico.aurum.com.br/contratos/politica-de-privacidade.pdf"
						>
							política de privacidade e cookies do site
						</a>
					</span>
				</div>
				<span className="footer_copyright_text">
					&copy; Aurum. Todos os direitos reservados.
				</span>
			</div>
		</footer>
	)
}
